import E, { useRef as i, useCallback as S, useState as d, useMemo as g, useEffect as y } from "react";
const F = (t, r) => {
  const e = i(null), o = S(
    (u, a) => {
      let f;
      return E.createElement(u, {
        ...a,
        open: !0,
        displayName: u == null ? void 0 : u.displayName,
        /**
         * Handler for the onClose event.
         */
        onClose: (l) => {
          var m;
          e != null && e.current && s(
            E.cloneElement(e.current, { open: !1 })
          ), f = "onClose", (m = a.onClose) == null || m.call(a, l, f);
        },
        /**
         * Handler for the onExited event.
         */
        onExited: () => {
          var l;
          s(null), (l = a.onExited) == null || l.call(a, f);
        },
        /**
         * Handler for the onSubmit event.
         */
        onSubmit: (l) => {
          var m;
          e != null && e.current && s(
            E.cloneElement(e.current, { open: !1 })
          ), f = "onSubmit", (m = a.onSubmit) == null || m.call(a, l);
        }
      });
    },
    []
  ), [n, s] = d(() => {
    if (t && !e.current) {
      const u = o(t, r);
      return e.current = u, u;
    }
    return null;
  });
  g(() => {
    e.current = n;
  }, [n]);
  const c = S(
    (u, a = { open: !1 }) => {
      const f = u == null ? null : o(u, a);
      s(f);
    },
    [o]
  );
  return [n, c];
}, C = "image/jpeg,image/jpg,image/png,image/gif,video/mp4,video/quicktime,application/zip,application/x-zip-compressed,multipart/x-zip", N = ({
  accept: t = C,
  multiple: r = !0
} = {}) => async () => await new Promise((e, o) => {
  const n = document.createElement("input");
  n.type = "file", n.setAttribute("accept", t), r && n.setAttribute("multiple", `${r}`), n.setAttribute("data-cy", "chooseFile"), n.setAttribute("style", "display: none"), n.onchange = (s) => {
    var u;
    const c = s.target;
    if (!((u = c.files) != null && u.length)) {
      o(new Error("No files selected"));
      return;
    }
    e(r ? Array.from(c.files) : c.files[0]);
  }, document.body.append(n), document.body.onfocus = () => {
    document.body.removeChild(n), document.body.onfocus = null;
  }, n.click();
}), M = () => (t) => {
  navigator.clipboard.writeText(t);
};
function b(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var h, p;
function j() {
  return p || (p = 1, h = function t(r, e) {
    if (r === e) return !0;
    if (r && e && typeof r == "object" && typeof e == "object") {
      if (r.constructor !== e.constructor) return !1;
      var o, n, s;
      if (Array.isArray(r)) {
        if (o = r.length, o != e.length) return !1;
        for (n = o; n-- !== 0; )
          if (!t(r[n], e[n])) return !1;
        return !0;
      }
      if (r.constructor === RegExp) return r.source === e.source && r.flags === e.flags;
      if (r.valueOf !== Object.prototype.valueOf) return r.valueOf() === e.valueOf();
      if (r.toString !== Object.prototype.toString) return r.toString() === e.toString();
      if (s = Object.keys(r), o = s.length, o !== Object.keys(e).length) return !1;
      for (n = o; n-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(e, s[n])) return !1;
      for (n = o; n-- !== 0; ) {
        var c = s[n];
        if (!t(r[c], e[c])) return !1;
      }
      return !0;
    }
    return r !== r && e !== e;
  }), h;
}
var D = j();
const q = /* @__PURE__ */ b(D), L = (t) => {
  const r = i(t), e = i(q);
  return g(() => (e.current(r.current, t) || (r.current = t), r.current), [t]);
}, _ = () => {
  const [t, r] = d(!1), e = i(null), o = () => r(!0), n = () => r(!1);
  return y(
    () => {
      const s = e.current;
      if (s)
        return s.addEventListener("mouseenter", o), s.addEventListener("mouseleave", n), () => {
          s.removeEventListener("mouseenter", o), s.removeEventListener("mouseleave", n);
        };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e.current]
    // Recall only if ref changes
  ), [e, t];
}, I = () => {
  const t = i(!0);
  return y(() => (t.current = !0, () => {
    t.current = !1;
  }), []), () => t.current;
}, J = (t) => {
  const r = JSON.parse(localStorage.getItem(t) || "null"), [e, o] = d(r);
  return {
    state: e,
    setFieldValue: (u, a) => {
      o((f) => {
        const l = {
          ...f,
          [u]: a
        };
        return localStorage.setItem(t, JSON.stringify(l)), l;
      });
    },
    getFieldValue: (u) => e == null ? void 0 : e[u],
    clear: () => {
      localStorage.removeItem(t), o(null);
    }
  };
}, v = (t) => {
  if (!t)
    return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}, P = (t) => {
  const [r, e] = d(
    () => v(localStorage.getItem(t))
  );
  return [r, (n) => {
    n !== null ? localStorage.setItem(t, JSON.stringify(n)) : localStorage.removeItem(t), e(n);
  }];
}, w = (t) => {
  const [r, e] = d(t), o = I(), n = S(
    (s) => {
      o() && e(s);
    },
    [o]
  );
  return g(
    () => [r, n],
    [r, n]
  );
}, x = (t) => {
  const r = i(void 0);
  return y(() => {
    r.current = t;
  }, [t]), r.current;
}, V = () => {
  const [t, r] = w(!1), e = i(0), o = S(
    async (n) => {
      r(!0), e.current++;
      try {
        return await n;
      } catch (s) {
        throw s;
      } finally {
        e.current--, e.current || r(!1);
      }
    },
    [r]
  );
  return g(
    () => [t, o],
    [t, o]
  );
}, R = (t) => {
  const [r, e] = d(
    v(sessionStorage.getItem(t))
  );
  return [r, (n) => {
    n !== null ? sessionStorage.setItem(t, JSON.stringify(n)) : sessionStorage.removeItem(t), e(n);
  }];
}, z = (t, { size: r = 5 } = {}) => {
  const e = i([]);
  return g(() => {
    if (t)
      return async (o = {}) => {
        const n = JSON.stringify(o), s = e.current.find((c) => c.key === n);
        if (s)
          return s.data;
        try {
          const c = await t(o), u = { data: c, key: n };
          return e.current[e.current.length % r] = u, setTimeout(() => {
            e.current = e.current.filter((a) => a !== u);
          }, 36e5), c;
        } catch (c) {
          console.error(c);
        }
      };
  }, [t, r]);
}, O = () => {
}, T = (t, r = []) => {
  const e = i(O);
  g(() => {
    e.current();
    const o = t(...r);
    e.current = o || O;
  }, [r]), y(() => () => {
    e.current();
  }, []);
};
export {
  F as useChildComponent,
  N as useChooseFiles,
  M as useCopyToClipboard,
  L as useEqualMemo,
  _ as useHover,
  I as useIsMounted,
  J as useLocalStorage,
  P as useLocalStorageState,
  w as useMountedState,
  x as usePrevious,
  V as useProcessAsync,
  R as useSessionStorageState,
  z as useSourceCache,
  T as useSubscribe
};
